"use client"
import React, { useEffect, useRef, useState} from "react";
import Select from "react-select";
import {BsFillBellFill} from 'react-icons/bs'
import classes from './search-bar.module.scss'
import './search-bar-select-global.scss'
import {usePathname, useRouter} from 'next/navigation'
import {Button, Container} from "components/ui";
import {useTekstClient} from "hooks/useTekstClient";
import {useAxios} from "hooks/useAxios";
import useGebruiker from "../../hooks/useGebruiker";
import {translateSegments} from "../../i18n/translateHelpers";

const PREFETCH_LIMIT = 50;
const PREFETCH_DEBOUNCE_MS = 600;

const SearchBar = () => {
    const {tekst} = useTekstClient()
    const {ingelogdeGebruiker} = useGebruiker()
    const searchRef = useRef(null);
    const prefetchTimerRef = useRef(null);
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const placeholder = tekst('pagina:menu:SearchBar:placeholder');
    const router = useRouter()
    const pathname = usePathname()
    const {get} = useAxios()
    const [isClient, setIsClient] = useState(false)

    useEffect(() => { setIsClient(true) }, [isClient])

    // Fire a prefetch request while the user pauses typing so the result is
    // already cached by the time the kenniscentrum page loads.
    const schedulePrefetch = (query) => {
        if (prefetchTimerRef.current) clearTimeout(prefetchTimerRef.current);
        if (!query || query.length < 2) return;
        prefetchTimerRef.current = setTimeout(() => {
            get(`/mijn-mkg/support/semantic-search?zoek=${encodeURIComponent(query)}&limit=${PREFETCH_LIMIT}`)
                .catch(() => {});
        }, PREFETCH_DEBOUNCE_MS);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const query = e.target.value;
            setInputValue(query);
            setSelectedValue({soort: 'tekst', id: 0, titel: query});
            searchRef.current.blur();
            return router.push(`/mijn-mkg/support/kenniscentrum?tekst=${encodeURIComponent(query)}`);
        }
    };

    // Visible URL segments are localized (/en-GB/my-mkg/support-chat) and useParams().lang is the internal nl-NL rewrite, so take the language from the pathname
    const [, locale] = pathname?.split('/') ?? [];
    if (pathname?.includes(translateSegments('/mijn-mkg/support-chat', locale?.split('-')[0]))) return null;

    return <div className={classes.searchWrapper}>
        <Container fluid="md" className={classes.containerMaxWidth}>
            <div className={classes.searchBarContainer}>
                {isClient && <Select
                    instanceId="main-search-bar"
                    className={classes.searchBarSelect}
                    classNamePrefix="mkgSearch"
                    ref={searchRef}
                    value={selectedValue}
                    onFocus={() => { if (selectedValue) setSelectedValue(null); }}
                    menuIsOpen={false}
                    openMenuOnFocus={false}
                    openMenuOnClick={false}
                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    placeholder={placeholder}
                    onInputChange={(value, {action}) => {
                        if (action !== 'input-change') return;
                        setInputValue(value);
                        schedulePrefetch(value);
                    }}
                    inputValue={inputValue}
                    options={[]}
                    filterOption={() => true}
                    onChange={() => {}}
                    onKeyDown={handleKeyDown}
                />}
                {((ingelogdeGebruiker?.groep?.mkger || [6, 17].includes(ingelogdeGebruiker?.groep?.id) ||
                  ingelogdeGebruiker?.meldingenbeheer) && ingelogdeGebruiker?.toonklantenkaart) ?
                    <Button className={classes.searchBarButton} onClick={() => router.push("/mijn-mkg/mijn-gegevens/meldingenbeheer")}>
                        <span><BsFillBellFill/></span>
                        <span>{tekst('pagina:mijn gegevens:meldingenbeheer:titel')}</span>
                    </Button> : <></>}
            </div>
        </Container>
    </div>
};

export default SearchBar;
